<template>
  <div class="app">
    <Loader />
    <Logo />
    <Menu />
    <Pointer />

    <div class="a-main">
      <div class="a-scroll">
        <transition
          v-bind:css="false"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:after-enter="afterEnter"
          v-on:before-leave="beforeLeave"
          v-on:leave="leave"
        >
          <router-view />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import Sniffer from 'sniffer';

// global
import Scroll from '@/js/scroll';
import Cursor from '@/js/cursor';
import Effects from '@/js/effects';
import Components from '@/js/components';
import Transitions from '@/js/transitions';

// components
import Logo from '@/components/logo/logo.vue';
import Menu from '@/components/menu/menu.vue';
import Loader from '@/components/loader/loader.vue';
import Pointer from '@/components/pointer/pointer.vue';

// init
Sniffer.addClasses(document.documentElement);
gsap.registerPlugin(ScrollToPlugin);

let scroll;
let cursor;
let effects;
let components;
let transitions;

// ipad pro fix
const ipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;

if (ipad === true) {
  document.querySelector('html').classList.add('is-device', 'is-ipad', 'is-tablet');
  document.querySelector('html').classList.remove('is-desktop');
}

// theme
if (window.location.hash) {
  const { hash } = window.location;
  if (hash === '#1') {
    document.body.classList.add('is-1');
  }
  if (hash === '#2') {
    document.body.classList.add('is-2');
  }
}

export default {
  components: {
    Logo,
    Menu,
    Loader,
    Pointer,
  },
  data() {
    return {
      scroll: null,
    };
  },
  methods: {
    beforeEnter(el) {
      setTimeout(() => {
        transitions.beforeEnter(el);
      });
    },
    enter(el, done) {
      setTimeout(() => {
        transitions.enter(el, done);
      });
    },
    afterEnter(el) {
      transitions.afterEnter(el);

      if (Sniffer.isDesktop && !ipad === true) {
        cursor.reset();

        scroll = new Scroll();
        this.scroll = scroll;
        scroll.init();
      }

      effects = new Effects();
      effects.init();

      components = new Components();
      components.init();

      transitions = new Transitions();
      transitions.init();
    },
    beforeLeave(el) {
      transitions.beforeLeave(el);
    },
    leave(el, done) {
      if (Sniffer.isDesktop && !ipad === true) {
        scroll.destroy();
      }

      effects.destroy();
      components.destroy();

      setTimeout(() => {
        transitions.leave(el, done);
      });
    },
  },
  mounted() {
    if (Sniffer.isDesktop && !ipad === true) {
      cursor = new Cursor();
      cursor.init();

      scroll = new Scroll();
      this.scroll = scroll;
      scroll.init();
    }

    effects = new Effects();
    effects.init();

    components = new Components();
    components.init();

    transitions = new Transitions();
    transitions.init();
  },
};
</script>

<style lang="scss">
@import "~@/main.scss";
</style>
